export default __webpack_public_path__ + "static/img-1@3x-a1b77aa200a3f3e6389edf2962cdea88.png";